import React, { useState } from "react";
import { NavLink } from 'react-router-dom';
import './footer.component.scss';

export default function Footer() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <span>© 2026 Calculus Circus</span>
        
        {/* Desktop links - hidden on mobile */}
        <div className="footer-links desktop-links">
          <a href="/about">About</a>
          <span className="footer-separator">•</span>
          <NavLink to="/contact">Contact</NavLink>
          <span className="footer-separator">•</span>
          <NavLink to="/privacy">Privacy</NavLink>
          <span className="footer-separator">•</span>
          <NavLink to="/termsofservice">Terms of Service</NavLink>
          <span className="footer-separator">•</span>
          <NavLink to="/plaintermsofservice">Student Terms</NavLink>
        </div>

        {/* Mobile hamburger menu */}
        <div className="mobile-menu-container">
          <button 
            className="hamburger-btn" 
            onClick={toggleMenu}
            aria-label="Toggle footer menu"
          >
            <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          </button>
          
          <div className={`mobile-links ${isMenuOpen ? 'open' : ''}`}>
            <a href="/about" onClick={() => setIsMenuOpen(false)}>About</a>
            <NavLink to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</NavLink>
            <NavLink to="/privacy" onClick={() => setIsMenuOpen(false)}>Privacy</NavLink>
            <NavLink to="/termsofservice" onClick={() => setIsMenuOpen(false)}>Terms of Service</NavLink>
            <NavLink to="/plaintermsofservice" onClick={() => setIsMenuOpen(false)}>Student Terms</NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
}